import type { User } from '@/features/participant';
import { useCallback, useState } from 'react';

export const useAddMemberForm = () => {
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleRemoveUser = useCallback((userToRemove: User) => {
    setSelectedUsers((prev) => prev.filter((u) => u.id !== userToRemove.id));
  }, []);

  const handleReset = useCallback(() => {
    setSelectedUsers([]);
    setIsSubmitting(false);
  }, []);

  const validateSelection = useCallback(() => {
    return selectedUsers.length > 0;
  }, [selectedUsers.length]);

  return {
    // State
    selectedUsers,
    setSelectedUsers,
    isSubmitting,
    setIsSubmitting,

    // Actions
    handleRemoveUser,
    handleReset,
    validateSelection
  };
};
